import {
  createTimeCodeRequest,
  CreateTimeCodeRequestType,
  deleteTimeCodeRequest,
  fetchTimeCodesRequest,
  editTimeCodeRequest,
} from 'api';
import { TimeCodeType } from 'state';
import {
  setAuthLoading,
  setNotification,
  setTimeCodes,
  setTimeCodesLoadingStatus,
} from 'state/actions';
import { TypedDispatch } from 'state/types';
import { convertNumberToTime, convertTimeToNumber } from 'utils';

export const fetchTimeCodes =
  (inspectionId: string) => async (dispatch: TypedDispatch) => {
    try {
      dispatch(setTimeCodesLoadingStatus(true));
      const response = await fetchTimeCodesRequest({ inspectionId });

      dispatch(setTimeCodes(response?.data.rows));
    } finally {
      dispatch(setTimeCodesLoadingStatus(false));
    }
  };

export const createTimeCode =
  (data: CreateTimeCodeRequestType) => async (dispatch: TypedDispatch) => {
    try {
      dispatch(setAuthLoading(true));
      const response = await createTimeCodeRequest(data);

      return response?.status;
    } finally {
      dispatch(setAuthLoading(false));
    }
  };

export const deleteTimeCode = (id: string) => async (dispatch: TypedDispatch) => {
  try {
    dispatch(setAuthLoading(true));
    const response = await deleteTimeCodeRequest(id);

    dispatch(setNotification(response?.data?.message));

    return response?.status;
  } finally {
    dispatch(setAuthLoading(false));
  }
};

export const editTimeCode =
  (timeCode: Omit<CreateTimeCodeRequestType, 'fileId'> & { id: string }) =>
  async (dispatch: TypedDispatch) => {
    try {
      dispatch(setAuthLoading(true));
      const response = await editTimeCodeRequest(timeCode);

      return response;
    } finally {
      dispatch(setAuthLoading(false));
    }
  };

export const splitTimeCode =
  ({
    tagId,
    fileId,
    id,
    timecodeStart,
    timecodeEnd,
    propertyAddress,
    propertyId,
  }: TimeCodeType) =>
  async (dispatch: TypedDispatch) => {
    try {
      dispatch(setAuthLoading(true));
      await createTimeCodeRequest({
        tagId,
        fileId,
        propertyAddress,
        propertyId,
        timecodeStart,
        timecodeEnd: convertNumberToTime(
          Math.round(
            (convertTimeToNumber(timecodeEnd) - convertTimeToNumber(timecodeStart)) / 2,
          ) + convertTimeToNumber(timecodeStart),
        ),
      });
      await createTimeCodeRequest({
        tagId,
        fileId,
        propertyAddress,
        propertyId,
        timecodeStart: convertNumberToTime(
          Math.round(
            (convertTimeToNumber(timecodeEnd) - convertTimeToNumber(timecodeStart)) / 2,
          ) + convertTimeToNumber(timecodeStart),
        ),
        timecodeEnd,
      });
      const response = await deleteTimeCodeRequest(id);

      return response?.status;
    } finally {
      dispatch(setAuthLoading(false));
    }
  };
